import NeighborhoodPageContent from "../NeighborhoodPageContent";

export default function PuertoDeLaTorre() {
  return <NeighborhoodPageContent slug="puerto-de-la-torre" />;
}